<template>
  <div class="section-container">
    <div class="container">
      <div class="page-caption">
        <h1 class="anders">mortgage notice</h1>
        <div class="point"></div>
        <h3 class="title">借款办理流程</h3>
      </div>
      <div class="row">
        <h1 class="row-side col-xs-2">办理流程</h1>
        <div class="paragraph-wrapper col-xs-10">
          <div class="item">
            <h4 class="item-title">提交借款订单申请</h4>
            <p>访问91weijia.com或关注官方微信号，在首页现在产品进入产品介绍页面，点击“立即申请”，进入贷款申请页面，填写贷款金额、贷款期限后，点击“提交订单”即可完成借款订单提交。</p>
          </div>
          <div class="item">
            <h4 class="item-title">完善个人信息</h4>
            <p>点击“我的”，找到已提交的借款订单，点击“完善收款信息”进入个人信息补充页面。完成实名认证及收款卡信息的录入。点击“确认”提交即可。</p>
          </div>
          <div class="item">
            <h4 class="item-title">线下实地考察</h4>
            <p>在完成个人信息录入后，伟嘉安捷贷款专员会第一时间联系您，确定相关贷款细节，并协助您办理相关资料及公证等。</p>
          </div>
          <div class="item">
            <h4 class="item-title">风控审核</h4>
            <p>在贷款资料准备完成后，提交贷款资料，由伟嘉安捷风控团队进行风控审核。</p>
          </div>
          <div class="item">
            <h4 class="item-title">放款</h4>
            <p>在风控审核通过后，即可请求放款</p>
          </div>
        </div>
      </div>
      <div class="page-caption">
        <div class="point"></div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
  .row
    margin-top 30px
</style>



// WEBPACK FOOTER //
// process.vue?e202cb56